


import Map from 'ol/Map';
import * as ol from 'ol';

import * as ol_style from 'ol/style';

import Feature from 'ol/Feature';
import Polygon from 'ol/geom/Polygon';

import { Vector as ol_layer_Vector, Vector } from 'ol/layer';
import { Vector as ol_source_Vector } from 'ol/source';
import { Point as ol_geom_Point } from 'ol/geom';
import { Circle as CircleStyle, Fill, RegularShape, Stroke, Style, Text } from 'ol/style';

import { FrCoordinate, FrLayer, OlMainComponent } from 'gmap';
import { OlMapBaseComponent } from 'gmap';
import { SupervisionError, Site, Panel } from 'solar-bo';
import { catchError } from 'rxjs/operators';
import { OlObjectTypeEnum } from 'solar-bo';
import GeoJSON from 'ol/format/GeoJSON';
import { throwError } from 'rxjs';
import { MapMarkerHelper } from 'gmap';
import { MapSupervisionHelper } from './map-supervision-helper';
import IconAnchorUnits from 'ol/style/IconAnchorUnits';
import { mapcte } from 'gmap';
import IconOrigin from 'ol/style/IconOrigin';


import { transform as ol_transform } from 'ol/proj';


import Point from 'ol/geom/Point';
import { Cluster, OSM, Vector as VectorSource } from 'ol/source';
//import { extend, getHeight, getWidth } from 'ol/extent';
import * as ol_extent from 'ol/extent';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';

import * as olInteraction from 'ol/interaction';
import { MapSiteHelper } from './map-site-helper';


export class MapSiteCluster {


  mapc: OlMainComponent;
  /**
 * sites layer
 */
  layerSites;
  mapSiteHelper: MapSiteHelper;
  styleCacheGlob = {};
  frlayerinfo = new FrLayer('Sites', 'sitesmarkers');
  //siteIcon = "assets/ol/site-panel-marker.png";
  siteIcon = "assets/ol/sitemarker.png";

  private maxFeatureCount;//used for color only
  private currentResolution;

  constructor(mapc: OlMainComponent, mapSiteHelper: MapSiteHelper) {
    this.frlayerinfo = new FrLayer('Sites', 'sitesmarkers');
    this.frlayerinfo.icon = "assets/ol/sitemarkerforlist.png";
    this.frlayerinfo.zoomToExtent = true;
    this.mapc = mapc;
    this.mapSiteHelper = mapSiteHelper;
  }
  //Styles -------------------------------
  siteStroke = new Stroke({
    color: '#fff',
    width: 0.5,
  });
  siteTextFill = new Fill({
    color: '#fff',
  });
  invisibleFill = new Fill({
    color: 'rgba(255, 255, 255, 0.01)',
  });
  /*   siteFill= new Fill({
      color: [11, 118, 119, +Math.min(0.5, 0.4 + size / this.maxFeatureCount).toFixed(2)],
    }); */
  //Styles END -------------------------------

  drawSitesClusterOnMap(sitesSelected: Site[]) {

    if (!this.mapc) {
      return;
    }
    try {
      this.mapSiteHelper.siteIcon = this.siteIcon;

      if (!sitesSelected || sitesSelected.length == 0) {
        return;
      }

      let frlayerinfo = this.frlayerinfo;
      let layer = this.mapc.layerGetByFrid(frlayerinfo.id);
      if (layer) {
        this.mapc.layerRemove(frlayerinfo.id);
      }

      let features: any[] = [];
      for (let item of sitesSelected) {
        let site: Site = item;
        if (site.info.location != null) {
          const feature = MapMarkerHelper.markerCreate(null, site.info.location[0], site.info.location[1], site.id, site.name);
          let layerExt = feature[mapcte.frlayerinfo_FieldName];
          layerExt.ref = OlObjectTypeEnum.site;
          layerExt.refObject = site;
          features.push(feature);
        }
      }

      let source = new VectorSource({
        features: features,
      });

      let clusterSource = new Cluster({
        distance: 15,
        source: source,
      });


      layer = new VectorLayer({
        source: clusterSource,
        style: this.clusterStyle.bind(this),
      });
      this.layerSites = layer;

      layer[mapcte.frlayerinfo_FieldName] = frlayerinfo;
      this.mapc.layerAdd(layer);

      if (sitesSelected.length == 1) {
        let site: Site = sitesSelected[0];
        if (site.geom) {

          let siteExtent = ol_extent.boundingExtent(site.geom.coordinates[0]);
          //ext = ol.proj.transformExtent(ext, ol.proj.get('EPSG:4326'), ol.proj.get('EPSG:3857'));
          setTimeout(() => {
            let view = this.mapc.map.getView();
            view.fit(siteExtent, { padding: [60, 60, 60, 60], duration: 2000 });
          }
            , 300);

        }
        else if (site.info.location) {
          this.mapc.setLocation(new FrCoordinate(site.info.location[0], site.info.location[1]));
          this.mapc.zoomUpgrade(17);

        }

      }
      else if (sitesSelected.length > 1) {
        setTimeout(() => this.setZoomToExtent2(layer, 2000), 300);
      }
      else {
        // this.mapc.setZoom(4);
      }

    } catch (ex) {
      console.log(ex);
      throw ex;
    }

  }

  setZoomToExtent(layer, duration: number = 0) {
    try {
      if (!layer) {
        return;
      }
      console.log("");
      let layerExtent = layer.getSource().getExtent();
      console.log("setZoomToExtent getExtent", layer, layerExtent);
      console.log("setZoomToExtent length:", layer.getSource().getFeatures().length);

      if (layerExtent) {


        let view = this.mapc.map.getView();
        view.fit(layerExtent, { padding: [60, 60, 60, 60], duration: duration });
      }
    }
    catch (err) {
      console.log(err);
    }

  }

  setZoomToExtent2(layer, duration: number = 0) {
    let featuresAs: any[] = layer.getSource().getFeatures();

    let map = this.mapc.map;
    let extent = ol_extent.createEmpty();
    for (let item of featuresAs) {
      let featuresList = item.get('features');
      if (featuresList != undefined) {

        featuresList.forEach(function (f, index, array) {
          ol_extent.extend(extent, f.getGeometry().getExtent());
        });

      }
    }
    if (extent) {
      let view = map.getView();
      view.fit(extent, { padding: [60, 60, 60, 60], duration: duration });
    }


  }


  private clusterStyle(feature, resolution) {

    if (resolution != this.currentResolution) {

      this.calculateClusterInfo(resolution, this.layerSites);
      this.currentResolution = resolution;
    }
    let styleCache = this.styleCacheGlob;
    let features = feature.get('features');
    let size = features.length;
    if (size == 1) {
      let originalFeature = feature.get('features')[0];;
      return this.mapSiteHelper.siteMapStyleFull(originalFeature, resolution);
    }
    let style = styleCache[size];
    if (!style) {
      //console.log("size:" + size + "--" + this.maxFeatureCount + "  Radius: " + feature.get('radius') + " Resolution:" + resolution);
      //colors: 11, 118, 119 verdoso
      //182 101 1 anarajando
      style = new Style({
        image: new CircleStyle({
          radius: feature.get('radius'),
          stroke: this.siteStroke,
          fill: new Fill({
            color: [192, 0, 0, +Math.min(0.5, 0.4 + size / this.maxFeatureCount).toFixed(2)],
          }),
        }),
        text: new Text({
          text: size.toString(),
          fill: this.siteTextFill,
        }),
      });
      styleCache[size] = style;
    }
    return style;
  }

  /**
  * Calc the radius fo the cluster based on extent
  * @param resolution 
  */
  calculateClusterInfo(resolution, layer: Vector) {
    this.maxFeatureCount = 0;
    let features = layer.getSource().getFeatures();;
    let feature;
    let radius;
    for (var i = features.length - 1; i >= 0; --i) {
      feature = features[i];
      let originalFeatures = feature.get('features');
      let extent = ol_extent.createEmpty();
      let j = (void 0), jj = (void 0);
      for (j = 0, jj = originalFeatures.length; j < jj; ++j) {
        ol_extent.extend(extent, originalFeatures[j].getGeometry().getExtent());
      }
      this.maxFeatureCount = Math.max(this.maxFeatureCount, jj);
      radius = (0.4 * (ol_extent.getWidth(extent) + ol_extent.getHeight(extent))) / resolution;
      //console.log("Radius: " + radius);
      feature.set('radius', Math.max(6, radius));
    }
  };

}